<template>
  <v-container class="pa-2">
    <v-card
      elevation="1"
      class="px-4 py-2 totalChat"
      tile
      color="#edf7ee"
      id="messageBody"
    >
      <div
        class="pb-2 innerChat"
        v-for="(item, index) in currentChat.Messages"
        :key="index"
      >
        <v-row justify="start" v-if="item.CategoryId !== ''" class="mt-2">
          <v-card
            elevation="1"
            width="100%"
            style="
              text-align: center;
              color: white;
              background-color: mediumseagreen;
            "
          >
            <h3>
              {{ $translate('NEW_SUBJECT') }}
              {{ setCorrectCategory(item.CategoryId) }}
            </h3>
          </v-card>
        </v-row>
        <!-- Message boxes from the user-->
        <v-row justify="start" v-if="item.PeerUserId !== ''">
          <v-col cols="12">
            <v-card elevation="1" class="d-inline-flex messageCardForUser">
              <v-hover v-if="item.MessageType === 'Picture'" v-slot="{ hover }">
                <v-img
                  style="cursor: pointer"
                  :src="item.PictureUrl"
                  contain
                  position="center"
                  max-height="200px"
                  max-width="200px"
                  @click="enlargeImage(item.PictureUrl)"
                >
                  <v-expand-transition>
                    <div
                      v-if="hover"
                      class="d-flex transition-fast-in-fast-out black darken-2 v-card--reveal display-3 white--text"
                      style="height: 100%"
                    >
                      <v-row justify="center">
                        <v-icon
                          x-large
                          style="background-color: white; opacity: 1 !important"
                        >
                          open_in_full
                        </v-icon>
                      </v-row>
                    </div>
                  </v-expand-transition>
                </v-img>
              </v-hover>
              <v-card-text
                v-else
                class="pa-2 textStyleUser my-auto"
                v-html="returnDescription(item.MessageText)"
              >
              </v-card-text>
            </v-card>
            <h4
              class="py-0 pr-0 mt-1"
              style="font-size: 10px; color: lightslategrey"
            >
              {{ item.SenderName }}:
              {{ returnCorrectTimeFormat(item.Timestamp) }}
            </h4>
          </v-col>
        </v-row>
        <!-- Message boxes from the partner-->
        <v-row justify="end" v-else>
          <v-col align="end" cols="12">
            <v-card elevation="1" class="d-inline-flex messageCardForPeer">
              <v-card-text
                class="pa-2 textStylePeer my-auto"
                v-html="returnDescription(item.MessageText)"
              ></v-card-text>
            </v-card>
            <h4
              class="py-0 pr-0 mt-1"
              style="font-size: 10px; color: lightslategrey"
            >
              {{ item.SenderName }}:
              {{ returnCorrectTimeFormat(item.Timestamp) }}
            </h4>
          </v-col>
        </v-row>
      </div>
    </v-card>
    <v-card tile elevation="1" class="pa-1 py-2 inputCard">
      <v-row justify="center">
        <v-col cols="12" md="8">
          <v-col cols="12" sm="6" md="4" class="pa-0">
            <v-select
              @input="newTopicSelected"
              v-model="selectedCategory"
              :items="chatSubjects"
              chips
              deletable-chips
              :label="$translate('NEW_SUBJECT')"
              item-text="Name"
              return-object
              solo
              flat
              outlined
              hide-details="auto"
            ></v-select>
          </v-col>

          <v-row class="ma-0 mt-3" align="center">
            <v-textarea
              :label="$translate('TYPE_MESSAGE_HERE')"
              auto-grow
              outlined
              rows="1"
              row-height="15"
              v-model="messageText"
              :disabled="loading"
              hide-details="auto"
            ></v-textarea>

            <v-btn
              v-if="messageText.trim().length"
              :loading="loading"
              icon
              dark
              large
              color="blue"
              @click="createMessage"
            >
              <v-icon size="35"> send </v-icon>
            </v-btn>
          </v-row>
        </v-col>
      </v-row>
    </v-card>
    <v-dialog max-width="600" max-height="400" v-model="enlargeImageDialog">
      <v-card>
        <v-card-title>
          <v-spacer></v-spacer>
          <v-btn icon color="primary" @click="enlargeImageDialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-row justify="center" class="ma-0 scrollPhoto">
          <v-img
            :src="selectedImage"
            contain
            position="center"
            height="100%"
            width="100%"
          />
        </v-row>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import doRequest from '@/api/dssRequest';
import utility from '@/shared/utility';

export default {
  name: 'ChatBubble',
  props: {
    currentChat: Object,
    categories: Array,
    selectedPartner: Object,
  },
  data() {
    return {
      interval: {},
      messageText: '',
      selectedImage: '',
      enlargeImageDialog: false,
      files: null,
      selectedCategory: {},
      loading: false,
    };
  },
  computed: {
    /**
     * check the PartnerAdminOnly value to filter the subjects
     * if PartnerAdminOnly is true remove it from the list because it's not necessary for the user
     * @returns {T[]}
     */
    chatSubjects() {
      // filter based on PartnerAdminOnly and put it in an array
      const subjects = this.categories.filter(
        (subject) => subject.PartnerAdminOnly === false
      );
      return subjects;
    },
  },
  watch: {},
  mounted() {
    this.selectedCategory = {};
    this.messageText = '';
    const self = this;
    // because its called in a interval you cant use this
    this.interval = setInterval(function () {
      self.emitParent();
    }, 15000);
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
  methods: {
    returnDescription(description) {
      return description.replace(/\n/g, '<br />');
    },
    emitParent() {
      this.$emit('getMessagesForUser', this.selectedPartner);
    },
    createMessage() {
      // Create message from User
      this.loading = true;
      const payload = {
        CategoryId: Object.keys(this.selectedCategory).length
          ? this.selectedCategory.CategoryId
          : '',
        PartnerGroupId:
          this.$store.getters['Account/partnerGroupDetails'].PartnerGroupId,
        SenderName:
          this.$store.getters['auth/user'].firstName !== ''
            ? `${this.$store.getters['auth/user'].firstName} ${this.$store.getters['auth/user'].lastName}`
            : this.$store.getters['auth/user'].email,
        MessageText: this.messageText,
        MessageType: 'Generic',
        Longitude: -200,
        Latitude: -200,
      };
      doRequest(
        (response) => {
          this.messageText = '';
          this.selectedCategory = {};
          this.loading = false;
          this.$emit('getMessagesForUser', this.selectedPartner);
        },
        (error) => {
          this.loading = false;
          window.EventBus.fire(
            'activateSnackBar',
            this.$translate('MESSAGE_NOT_SEND')
          );
        },
        'createMessage',
        this.selectedPartner.AccountId +
          '_UG_' +
          this.selectedPartner.PartnerId,
        payload
      );
    },

    newTopicSelected(data) {
      data !== null
        ? (this.selectedCategory = data)
        : (this.selectedCategory = {});
      this.messageText = '';
      this.messageText = data.Description;
    },
    fileSelected(e) {
      // this.files = e.target.files;
      this.files = e.target.files[0].name;
    },
    returnCorrectTimeFormat(unixTimestamp) {
      return utility.unixTimeToDateTimeString(unixTimestamp);
    },
    setCorrectCategory(categoryId) {
      for (let i = 0; i < this.categories.length; i++) {
        if (this.categories[i].CategoryId === categoryId) {
          return this.categories[i].Name;
        }
      }

      return '';
    },
    enlargeImage(url) {
      this.selectedImage = url;
      this.enlargeImageDialog = true;
    },
  },
};
</script>

<style scoped lang="scss">
.messageCardForUser {
  background-color: grey !important;
  border-radius: 10px 10px 10px 0px !important;
}
.messageCardForPeer {
  background-color: dodgerblue !important;
  border-radius: 10px 10px 0px 10px !important;
}
.textStylePeer {
  color: white !important;
  font-size: 15px;
  text-align: start;
}
.textStyleUser {
  color: white !important;
  font-size: 15px;
}
.totalChat {
  /*direction: rtl;*/
  /*<!--transform: rotate( -180deg );-->*/
  max-height: calc(50vh);
  /*overflow-y: scroll;*/
  /*overflow-x: hidden;*/
  /*flex-direction: column-reverse;*/
  /*height: 100px;*/
  min-height: calc(40vh);
  overflow: auto;
  display: flex;
  flex-direction: column-reverse;
}
.innerChat {
  /*direction: ltr;*/
  /*<!--transform: rotate( -180deg );-->*/
}
.scrollPhoto {
  max-height: calc(80%);
  overflow-y: auto;
  overflow-x: hidden;
}
.v-card--reveal {
  align-items: center;
  bottom: 0;
  justify-content: center;
  opacity: 0.5;
  position: absolute;
  width: 100%;
}
</style>
